var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWelcomePage3(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 354,
    height: 190,
    viewBox: "0 0 354 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_3323)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_80_3323)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18.5,
    y: 43,
    width: 317,
    height: 131,
    rx: 8,
    fill: "white"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 57,
    width: 73,
    height: 8,
    rx: 4,
    fill: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 57,
    width: 47,
    height: 8,
    rx: 4,
    fill: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 61,
    r: 7,
    fill: "#DBEFF8"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 60.9999,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 55.5556,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 66.4442,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 89,
    width: 48,
    height: 8,
    rx: 4,
    fill: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.5,
    y: 89,
    width: 75,
    height: 8,
    rx: 4,
    fill: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 93,
    r: 7,
    fill: "#FCD9E0"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 92.9999,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 87.5556,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 98.4442,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 121,
    width: 73,
    height: 8,
    rx: 4,
    fill: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.5,
    y: 121,
    width: 84,
    height: 8,
    rx: 4,
    fill: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 125,
    r: 7,
    fill: "#D4FDE6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 125,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 119.556,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 130.444,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58.5,
    y: 153,
    width: 89,
    height: 8,
    rx: 4,
    fill: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158.5,
    y: 153,
    width: 47,
    height: 8,
    rx: 4,
    fill: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 36.5,
    cy: 157,
    r: 7,
    fill: "#ECDCF6"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 157,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 151.556,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 318.5,
    cy: 162.444,
    r: 1.55556,
    fill: "#C4C4C4"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.5,
    y1: 76.5,
    x2: 325.5,
    y2: 76.5,
    stroke: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.5,
    y1: 108.5,
    x2: 325.5,
    y2: 108.5,
    stroke: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.5,
    y1: 140.5,
    x2: 325.5,
    y2: 140.5,
    stroke: "#EBEEEF"
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_80_3323)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 228.5,
    y: 16,
    width: 54,
    height: 54,
    rx: 27,
    fill: "#D4FDE6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.5 47.0002V51.0002H247.5V47.0002H244.833V51.0002C244.833 52.4668 246.033 53.6668 247.5 53.6668H263.5C264.967 53.6668 266.167 52.4668 266.167 51.0002V47.0002H263.5ZM262.167 41.6668L260.287 39.7868L256.833 43.2268V32.3335H254.167V43.2268L250.713 39.7868L248.833 41.6668L255.5 48.3335L262.167 41.6668Z",
    fill: "#00C282"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_80_3323",
    x: 2.5,
    y: 31,
    width: 349,
    height: 163,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_3323"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_3323",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_80_3323",
    x: 212.5,
    y: 4,
    width: 86,
    height: 86,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 8
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.12 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_80_3323"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_80_3323",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_3323"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 353,
    height: 190,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWelcomePage3);
export default __webpack_public_path__ + "static/media/welcome_page3.f12f7062fb2a634259513497da6a427d.svg";
export { ForwardRef as ReactComponent };